export const GET_TASK_ACTION = 'tasksActions/GET_TASK_ACTION'
export const SET_TASK_ACTION = 'tasksActions/SET_TASK_ACTION'

export const SET_IS_LOADING_TASK = 'tasksActions/SET_IS_LOADING_TASK'
